import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/auth/service/user.service';
import { ActivityTrackerService } from 'src/app/services/activity-tracker.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { UserCardioService } from 'src/app/services/user-cardio.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fit-reconcile-activities',
  templateUrl: './fit-reconcile-activities.component.html',
  styleUrls: ['./fit-reconcile-activities.component.scss'],
})
export class FitReconcileActivitiesComponent implements OnInit {
  isLoading = false;
  syncedActivities: any = [];
  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private userCardioService: UserCardioService,
    private router: Router,
    private userTaskStatusService: UserTaskStatusService,
    private activityTrackerService: ActivityTrackerService
  ) {}

  ngOnInit(): void {
    this.isLoading = false;

    this.fetchSyncedActivities();
  }

  fetchSyncedActivities() {
    this.userCardioService.fetchSyncedActivities().subscribe((responseData) => {
      this.syncedActivities = responseData;
      this.syncedActivities.forEach((activity: any, index: number) => {
        this.syncedActivities[index].activity_data = JSON.parse(
          this.syncedActivities[index].activity_data
        );
      });
    });
  }

  onDelete(syncedActivitity: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to undo this",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Yes, delete it',
    }).then((result) => {
      if (result.value) {
        this.userCardioService
          .setSyncedActivityStatus(syncedActivitity.user_synced_activity_id, 2)
          .subscribe(
            (responseData: any) => {
              Swal.fire('Your entry has been deleted', 'success');
              syncedActivitity.status = 2;
              this.fetchSyncedActivities();
            },
            (error) => {
              this.isLoading = false;
              Swal.fire(
                'Error',
                'An unknown error has occured, please contact us',
                'error'
              );
            }
          );
      }
    });
  }
}
